import { render, staticRenderFns } from "./MarketplaceUnreadBadge.vue?vue&type=template&id=0fa24f5a&scoped=true"
import script from "./MarketplaceUnreadBadge.vue?vue&type=script&lang=js"
export * from "./MarketplaceUnreadBadge.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceUnreadBadge.vue?vue&type=style&index=0&id=0fa24f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa24f5a",
  null
  
)

export default component.exports